<div>
  <div class="pt-0">
    <div class="mb-5 flex items-center justify-between">
      <h5 appDynamicFontSize="subtitle" class="font-semibold dark:text-white-light">{{ 'title_change_pwd' | translate }}</h5>
    </div>
    <div>
      <form
        [formGroup]="changePasswordForm"
        (ngSubmit)="onChangePassword()"
        class="mb-5 rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726]"
      >
        <div class="flex flex-col sm:flex-row">
          <div class="grid flex-1 gap-5 sm:grid-cols-2">
            <div>
              <label for="old_password" class="form-label">{{ 'form_label_old_pwd' | translate }}</label>
              <input type="password" formControlName="old_password" class="form-input" id="old_password" />
              @if (changePasswordForm.get('old_password')?.invalid && changePasswordForm.get('old_password')?.touched) {
              <div class="text-red-500">
                {{ 'form_old_pwd_req_msg' | translate }}
              </div>
              }
            </div>
            <div>
              <label for="new_password" class="form-label">{{ 'form_label_new_pwd' | translate }}</label>
              <input type="password" formControlName="new_password" class="form-input" id="new_password" />
              <!--<div *ngIf="changePasswordForm.get('new_password')?.invalid && changePasswordForm.get('new_password')?.touched" class="text-red-500">
              {{ 'form_label_confirm_new_pwd' | translate }}
            </div>-->
              @if (changePasswordForm.get('new_password')?.invalid && changePasswordForm.get('new_password')?.touched) {
              <div class="text-red-500">
                @if ( changePasswordForm.get('new_password')?.errors?.['passwordInvalid'] ) {
                <!-- {{ passwordValidationMessage }}-->
                }
                <!--<ng-container
                  *ngIf="
                  changePasswordForm.get('new_password')?.errors?.['minlength']
                "
                >
                Password must be at least 8 characters long.
              </ng-container>-->
              </div>
              } @if (changePasswordForm.controls['new_password'].touched && !allConditionsMet) {
              <div class="passwordCharMatch text-red-500">
                {{ passwordValidationMessage }}
              </div>
              }
            </div>
            <div>
              <label for="confirm_new_password" class="form-label">{{ 'form_label_confirm_new_pwd' | translate }}</label>
              <input type="password" formControlName="confirm_new_password" class="form-input" id="confirm_new_password" />
              @if (changePasswordForm.get('confirm_new_password')?.invalid && changePasswordForm.get('confirm_new_password')?.touched) {
              <div class="text-red-500">
                {{ 'form_confirm_new_pwd_req_msg' | translate }}
              </div>
              }
            </div>
          </div>
        </div>

        <div class="mt-5 flex flex-col items-center">
          <button appDynamicFontSize="body" type="submit" class="btn btn-primary">
            {{ 'form_submit_btn' | translate }}
          </button>
          <p class="mt-3 text-center text-sm text-gray-500 dark:text-gray-400"><strong>Note:</strong> {{ passwordValidationMessage }}</p>
        </div>
      </form>
    </div>
  </div>
</div>
